import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WelcomePage from './pages/WelcomePage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import DashboardHome from './pages/DashboardHome';
import DashboardUsers from './pages/DashboardUsers';
import DashboardPosts from './pages/DashboardPosts';
import DashboardSponsorships from './pages/DashboardSponsorships';
import DashboardReports from './pages/DashboardReports';
import SettingsPage from './pages/SettingsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/login" element={<LoginPage />} />
        
        {/* Dashboard route with nested routes */}
        <Route path="/dashboard" element={<AdminDashboard />}>
          <Route index element={<DashboardHome />} />
          <Route path="users" element={<DashboardUsers />} />
          <Route path="posts" element={<DashboardPosts />} />
          <Route path="sponsored" element={<DashboardSponsorships />} />
          <Route path="report"element={<DashboardReports />} />
          <Route path="settings" element={<SettingsPage />}  />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
